import { render } from "./integrationForm.vue?vue&type=template&id=71f12b96"
import script from "./integrationForm.vue?vue&type=script&lang=js"
export * from "./integrationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__